import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Dominio público del portal (también en public/index.html, robots.txt y sitemap.xml)
export const PORTAL_URL = "https://portal.domicilapp.com";

interface SeoOptions {
    title: string;
    description?: string;
    // Solo /login y /signup se indexan; las pantallas privadas usan index: false
    index?: boolean;
}

// Crea o actualiza una etiqueta <meta> o <link> del <head>
const setTag = (selector: string, create: () => HTMLElement, attr: string, value: string) => {
    let el = document.head.querySelector<HTMLElement>(selector);
    if (!el) {
        el = create();
        document.head.appendChild(el);
    }
    el.setAttribute(attr, value);
};

const setMeta = (key: "name" | "property", name: string, content: string) =>
    setTag(`meta[${key}="${name}"]`, () => {
        const meta = document.createElement("meta");
        meta.setAttribute(key, name);
        return meta;
    }, "content", content);

// Título de la pestaña y etiquetas para buscadores de la pantalla actual
export const useSeo = ({ title, description, index = false }: SeoOptions) => {
    const { pathname } = useLocation();

    useEffect(() => {
        document.title = title;
        setMeta("name", "robots", index ? "index, follow, max-image-preview:large" : "noindex, nofollow");
        if (!index) return;

        const url = PORTAL_URL + pathname;
        setTag('link[rel="canonical"]', () => {
            const link = document.createElement("link");
            link.setAttribute("rel", "canonical");
            return link;
        }, "href", url);
        setMeta("property", "og:url", url);
        setMeta("property", "og:title", title);
        setMeta("name", "twitter:title", title);
        if (description) {
            setMeta("name", "description", description);
            setMeta("property", "og:description", description);
            setMeta("name", "twitter:description", description);
        }
    }, [title, description, index, pathname]);
};
